import { Directive, Input, OnChanges, SimpleChanges, HostListener } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn, Validators } from '@angular/forms';
import { DISALLOWED_WORDS_REGEX, DISALLOWED_WORDS } from '../models/disallowed-words';

/** input must be greater than length */
export function minLengthValidator(length: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {

        var isValid = (control.value && control.value.length >= length) ? true : false;




        return !isValid ? { 'minimumLength': { value: control.value } } : null;
    };
}




@Directive({
    selector: '[minimumLength]',
    //providers: [{ provide: NG_VALIDATORS, useExisting: DisallowedWordsValidatorDirective, multi: true }]
})
export class MinimumLengthValidatorDirective {

    @Input()
    minimumLength: AbstractControl;

    @Input()
    length: number;


    @HostListener('focusout', ['$event.target'])
    onFocusout(target) {

        this.validate();
    }

    @HostListener('document:triggerValidation', ['$event.target'])
    onsubmit() {

        this.validate();
    }

    validate() {


        if (!this.minimumLength.errors) {

            this.minimumLength.setErrors(minLengthValidator(this.length)(this.minimumLength));

        }
    }



}

